// Realitní kancelář – zámek mapy na detailu ([data-ro-map], markup detail/map.php, návrh ř. 375–381).
// Průhledné tlačítko přes iframe Mapy.com, aby kolečko myši rolovalo stránku, ne mapu. Bez JS je tlačítko
// schované (mapa rovnou ovladatelná). Klik odemkne, odchod myši z mapy zamkne.

export default function initRoMapLock() {
  document.querySelectorAll('[data-ro-map]').forEach((map) => {
    const lock = map.querySelector('[data-ro-map-lock]');
    if (!lock) {
      return;
    }
    lock.hidden = false;
    lock.addEventListener('click', () => {
      lock.hidden = true;
    });
    map.addEventListener('mouseleave', () => {
      lock.hidden = false;
    });
  });
}
